import { create } from 'zustand';
import { PaginationType } from '../../../types';

/**
 * Focus Chats store
 */
interface useFocusChatsStore {
  focusMessageFilters: {
    searchText: string;
    groupId: string;
  };
  isLoading: boolean;
  focusMessageConversationList: any;
  totalConversationsCount: number;
  selectedChat: any;
  isFetchedChatById: boolean;
  pagination: PaginationType;
  error: boolean;
  setState(nextState: Partial<useFocusChatsStore>): void;
  getChatById(chatId: string): any | null;
  addChatToTop(chat: any): void;
  removeChatById(focusMessageId: string): void;
}

const initialPagination = {
  limit: 50,
  page: 1,
  total: 0,
  pages: 0,
};

export const initialFocusChatsState = {
  focusMessageFilters: {
    searchText: '',
    groupId: '',
  },
  isLoading: true,
  focusMessageConversationList: [],
  totalConversationsCount: 0,
  selectedChat: {},
  isFetchedChatById: true,
  pagination: initialPagination,
  error: false,
};

const useFocusChats = create<useFocusChatsStore>((set, getState) => ({
  ...initialFocusChatsState,
  setState: nextState => set(state => ({ ...state, ...nextState })),
  setSearchTextFilterValue: (searchText: string) =>
    set(state => ({
      focusMessageFilters: {
        ...state.focusMessageFilters,
        searchText,
      },
    })),
  getChatById: (chatId: string) => {
    return getState().focusMessageConversationList.find((chat: any) => chat?.focusMessage?._id === chatId) ?? null;
  },
  addChatToTop: chat =>
    set(state => {
      const existing = state.focusMessageConversationList.find((c: any) => c.chatId === chat._id);

      const mergedChat = existing ? { ...existing, ...chat } : chat;

      const rest = state.focusMessageConversationList.filter((c: any) => c.chatId !== chat._id);

      return {
        focusMessageConversationList: [mergedChat, ...rest],
      };
    }),
  removeChatById: (focusMessageId: string) =>
    set(state => ({
      focusMessageConversationList: state.focusMessageConversationList.filter(
        (chat: any) => chat?.focusMessage?._id !== focusMessageId
      ),
    })),
}));

export default useFocusChats;
